import styles from './index.module.css';
import defaultStyles from '../../styles/formSetStyles.module.css';

interface Props extends React.PropsWithChildren {
  label: string;
  subLabel?: string;
  uppercaseLabel?: boolean;
  htmlFor?: string;
}

const LabeledInput: React.FC<Props> = ({
  htmlFor,
  label,
  subLabel,
  uppercaseLabel,
  children,
}) => (
  <div key={label} className={defaultStyles.InputDiv}>
    <label htmlFor={htmlFor} className={defaultStyles.InputLabel}>
      {uppercaseLabel ? label.toUpperCase() : label}
    </label>
    {subLabel ? <div className={styles.SubLabel}>{subLabel}</div> : null}
    {children ? <div className={styles.Children}>{children}</div> : null}
  </div>
);

export default LabeledInput;
